import { create } from 'zustand';
import api from 'core/api';
import axios from 'utils/axios';
import { CURRENT_NOTIFICATION } from 'utils/api';

import pages from '../../../components/Common/Notification/Item/pages';

const useNotificationStore = create(
  (set, get) => ({
    open: false,
    setOpen: (value) => {
      set(state => ({
        ...state,
        open: value,
      }));
    },
    setCurrentNotification: (value) => {
      set(state => ({
        ...state,
        ...value,
      }));
    },
    currentProposal: {},
    setCurrentProposal: (value) => {
      set(state => ({
        ...state,
        currentProposal: value,
      }));
    },
    getCurrentNotification: ({ externalId, history, type, action }) => {
      let config = {};
      if (type === 'download') {
        config = { responseType: 'blob' };
      }

      axios.get(CURRENT_NOTIFICATION.replace('{guid}', externalId), config).then((response) => {
        if (type === 'download') {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `relatorio_${new Date().getTime()}.xlsx`;
          link.click();
          document.removeChild(link);
          get().setOpen(false);
        }
        if (type === 'redirect') {
          if (
            response.status === 200
            && Object.entries(pages).filter(item => item[0] === 'Unwinding').length > 0
          ) {
            get().setOpen(false);
            // eslint-disable-next-line dot-notation
            history.push(pages[action]);
          }
        }
      });
    },
  }),
);

export default useNotificationStore;
